// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderNewScreenComponent_container__3X-8q"};